import { Dialog } from '@mui/material';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setUploadGuidelineVideoDialogOpen } from '../../redux/reducers/loginSlice';
import VideoPlayer from 'react-video-js-player';
import { X } from 'lucide-react';

const UploadGuidelineVideoModel = () => {
    const dispatch = useDispatch();
    const open = useSelector(state => state.login.isUploadGuidelineDialogOpen);

    const handleClose = () => {
        dispatch(setUploadGuidelineVideoDialogOpen(false));
    };

    return (
        <Dialog
            onClose={handleClose}
            open={open}
            maxWidth="md"
            fullWidth
            PaperProps={{
                className: "rounded-2xl overflow-hidden bg-transparent shadow-none"
            }}
            BackdropProps={{
                className: "backdrop-blur-sm bg-black/40"
            }}
        >
            <div className="relative bg-white rounded-3xl overflow-hidden shadow-2xl flex flex-col max-h-[90vh]">
                {/* Header */}
                <div className="flex items-center justify-between px-8 py-6 border-b border-slate-100 bg-gradient-to-r from-slate-50 to-white">
                    <div>
                        <h2 className="text-2xl font-bold text-[#247E45]">
                            Guideline Video
                        </h2>
                        <p className="text-sm text-slate-500 mt-1">
                            Follow these instructions for the best results
                        </p>
                    </div>

                    <button
                        onClick={handleClose}
                        className="p-2 rounded-full hover:bg-slate-100 text-slate-400 hover:text-slate-600 transition-all duration-200 focus:outline-none ring-2 ring-transparent focus:ring-slate-200"
                    >
                        <X size={24} />
                    </button>
                </div>

                {/* Video Container */}
                <div className="p-8 bg-slate-50 flex items-center justify-center">
                    <div className="relative w-full rounded-2xl overflow-hidden shadow-lg border-4 border-white bg-black">
                        <VideoPlayer
                            src="/assets/GuidelinesVideo.mp4"
                            controls={true}
                            autoplay={true}
                            muted={false}
                            className="w-full h-full aspect-video object-contain"
                            width="100%"
                            height="100%"
                        />
                    </div>
                </div>

                {/* Footer Tip (Optional, adds polish) */}
                <div className="px-8 py-4 bg-white border-t border-slate-100 text-center">
                    <p className="text-sm text-slate-400 font-medium">
                        Tips: Ensure good lighting and keep the camera steady
                    </p>
                </div>
            </div>
        </Dialog>
    );
};

export default UploadGuidelineVideoModel;